import { mapActions, mapGetters, mapState } from 'vuex';
import disqusMixin from '@/mixins/disqus';

export default {
  mixins: [
    disqusMixin,
  ],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    focusCommentId: {
      type: String,
      default: '',
    },
    requestedCommentThreadId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters('app', ['isPinningEnabled']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('market', ['market', 'isDiscussionPinned']),
  },
  methods: {
    ...mapActions('market', ['toggleDiscussionPin']),
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/pages/sushi-market-discussion/sushi-market-discussion.js